/** Divetta R7 — native navigation with a disposable, fail-open transition. */
(() => {
  'use strict';
  const KEY = '__DivettaPageTransition';
  window[KEY]?.destroy?.();
  const controller = new AbortController();
  const { signal } = controller;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const STORAGE = 'ld_page_transition_v2';
  let emergencyTimer = 0, fallbackTimer = 0, frame = 0, navigating = false;
  const overlay = () => document.querySelector('[data-dv2-page-transition]');
  const cleanup = () => {
    clearTimeout(emergencyTimer); clearTimeout(fallbackTimer); cancelAnimationFrame(frame);
    emergencyTimer = fallbackTimer = frame = 0; navigating = false;
    document.documentElement.classList.remove('dv2-transition-arriving');
    delete document.documentElement.dataset.dv2TransitionWorld;
    document.body?.classList.remove('dv2-transition-active');
    overlay()?.classList.remove('is-active');
    overlay()?.setAttribute('aria-hidden', 'true');
    document.getElementById('MainContent')?.removeAttribute('aria-busy');
    try { sessionStorage.removeItem(STORAGE); } catch (_) {}
  };
  const destination = (event, link) => {
    if (!(link instanceof HTMLAnchorElement) || event.defaultPrevented || event.button !== 0) return null;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return null;
    if (window.Shopify?.designMode || link.closest('[data-dv2-home]')?.dataset.transitionEnabled === 'false') return null;
    try {
      const url = new URL(link.href, location.href);
      if (!['http:', 'https:'].includes(url.protocol) || url.origin !== location.origin) return null;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return null;
      if (/\/(cart|checkout|checkouts|account|apps)(\/|$)/.test(url.pathname)) return null;
      return url;
    } catch (_) { return null; }
  };
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[data-dv2-transition]') : null;
    const url = destination(event, link);
    if (!url || navigating) return;
    try { window.DV2HomeReturn?.saveForLink?.(link); } catch (_) {}
    if (reduced.matches || !overlay()) return;
    const node = overlay();
    const world = link.dataset.dv2WorldLink || link.dataset.dv2DestinationWorld || document.querySelector('[data-dv2-home]')?.dataset.activeWorld || 'neutral';
    node.dataset.world = world;
    const label = node.querySelector('[data-dv2-transition-label]');
    if (label) label.textContent = link.dataset.dv2Destination === 'product' ? 'Il tuo prossimo rituale' : 'Dentro il mondo Divetta';
    try { sessionStorage.setItem(STORAGE, JSON.stringify({ world, timestamp: Date.now(), destination: url.pathname })); } catch (_) {}
    document.body.classList.add('dv2-transition-active');
    node.classList.add('is-active');
    document.getElementById('MainContent')?.setAttribute('aria-busy', 'true');
    event.preventDefault(); navigating = true;
    let invoked = false;
    const navigate = () => { if (invoked) return; invoked = true; location.assign(url.href); };
    frame = requestAnimationFrame(navigate);
    fallbackTimer = setTimeout(navigate, 120);
    emergencyTimer = setTimeout(cleanup, 3000);
  }, { capture: true, signal });
  window.addEventListener('pageshow', cleanup, { signal });
  window.addEventListener('pagehide', () => { clearTimeout(emergencyTimer); clearTimeout(fallbackTimer); cancelAnimationFrame(frame); }, { signal });
  reduced.addEventListener?.('change', cleanup, { signal });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanup, { once: true, signal }); else cleanup();
  window[KEY] = { destroy() { controller.abort(); cleanup(); delete window[KEY]; } };
})();
